
import EoTiktok from "../../EoTiktok/EoTiktok.vue"

export default {
  name: "PreprTikTokPost",
  components: { EoTiktok },
  props: {
    /**
     * Prepr data of this element
     */
    data: {
      type: Object,
      default: () => { },
    },
    /**
     * Prop and attribute overwrites
     */
    overwrites: {
      type: Object,
      default: () => {
        return {}
      },
    },
    /**
     * Index
     */
    index: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      // Prepr data model https://developers.prepr.io/reference#tiktokpost
      dataModel: {
        url: null,
      },
    }
  },
  computed: {
    normalizedData() {
      return { ...this.dataModel, ...this.data }
    },
    isCookiesAllowed() {
      return this.$parent.allowedCookies?.includes('social')
    },
  },
}
